<template>
  <div class="row">
    <div class="col-12">
      <div class="card card-bottom-radius-8" style="background-color: #f9f9f9;">
        <div class="card-block">
          <form autocomplete="off" role="presentation">
            <div class="form-group row">
              <div class="col-md-12">
                <strong><i class="fas fa-money-check-alt text-default"></i> REEMBOLSO VIAGEM </strong>
                <div v-if="HasData == true && this.obj != null && (this.obj.situacao === null || this.obj.situacao === 0)" class="edit-board d-none"><a href="javascript:void(0);" @click="onEdit"><i class="fas fa-edit"></i>&nbsp;<small>Editar</small></a></div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>Obra:</label>
                <div class="input-group">
                  <strong>{{Obra}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <label>Data Solicitação:</label>
                <div class="input-group">
                  <strong>{{RequestDate}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <label>Situação:</label>
                <div class="input-group">
                  <strong>{{Stage}}</strong>
                </div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>Responsável <small>(Coordernador obra)</small>:</label>
                <div class="input-group">
                  <strong>{{Responsible}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <label>Regional</label>
                <div class="input-group">
                  <strong>{{BranchName}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <label>Solicitante:</label>
                <div class="input-group">
                  <strong>{{Requester}}</strong>
                </div>
              </div>
            </div>
            <div class="form-group row " style="border-bottom: dotted 1px #ccc; padding-top: 5px;"><div class="col-md-12"></div></div>
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>Período Viagem</label>
                <div class="input-group">
                  <strong>{{TravelPeriod}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <label>Cidade Viagem <small>(Origem/Destino)</small>:</label>
                <div class="input-group">
                  <strong>{{TravelCity}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <label>Motivo Viagem:</label>
                <div class="input-group">
                  <strong>{{ReasonTravel}}</strong>
                </div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>Funcionário:</label>
                <div class="input-group">
                  <strong>{{Favored}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <label>Funcionário Função:</label>
                <div class="input-group">
                  <strong>{{FavoredPosition}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <div class="input-group pt-2">
                  <button type="button"
                          v-if="this.obj.situacao === 0"
                          class="btn btn-third btn-sm mr-1"
                          v-b-tooltip.hover
                          title="Enviar para Aprovação"
                          @click="onSectionApproval">
                    <i class="fas fa-play-circle"></i> Enviar para Aprovação
                  </button>
                  <b-dropdown variant="danger" no-caret
                          v-if="this.obj.situacao === 0">
                    <template slot="button-content">
                      <i class="fa fa-trash"></i> Excluir
                    </template>
                    <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
                    <b-dropdown-item href="javascript:void(0);" v-on:click="onDelete">{{$lang.Common.Yes}}</b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
                  </b-dropdown>
                  <button type="button"
                          v-if="HasData === true && this.obj != null && this.obj.situacao  > 0  && this.obj.situacao  <= 4   && canNotEdit() &&  this.obj.situacao != 2"
                          class="btn btn-success btn-sm mr-1"
                          v-b-tooltip.hover
                          title="Clique para Aprovar"
                          @click="onApproval">
                    <i class="fas fa-check-circle"></i> Aprovar
                  </button>
                  <button type="button"
                          v-if="HasData === true && this.obj != null && this.obj.situacao  > 0 &&  this.obj.situacao <= 4  &&  this.obj.situacao != 2 && canNotEdit()"
                          class="btn btn-danger btn-sm mr-1"
                          v-b-tooltip.hover
                          title="Clique para Reprovar"
                          @click="onDisapproval">
                    <i class="fas fa-times-circle"></i> Reprovar
                  </button>
                  <button type="button"
                          v-if="HasData == true && this.obj != null && this.obj.situacao > 3 && canNotEdit()"
                          class="btn btn-default btn-sm mr-1 d-none"
                          v-b-tooltip.hover
                          title="Clique para Gerar o Arquivo de Exportação"
                          @click="exportFile = !exportFile">
                    <i class="fas fa-file-export"></i> Exportar Arquivo
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <label>
                  Observações:&nbsp;
                  <a v-if="showObservations == false" href="javascript:void(0);" @click="showObservations = true">
                    <i class="fas fa-plus-square"></i>
                  </a>
                  <a v-else href="javascript:void(0);" @click="showObservations = false">
                    <i class="fas fa-minus-square"></i>
                  </a>
                </label>
                <div v-show="showObservations" class="input-group">
                  <span class="edit-observations">{{Observations}}</span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PermisionMixin from '@/store/module/permission/mixin'
import Tools from '@/components/tools/Tools.js'
import ExpenseRepository from '@/shared/http/repositories/business/expense.js'
import { loading } from '@/shared/utils/UIHelper'
import roles from '@/shared/utils/roles'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'

export default {
  name: 'MiscellaneousExpenseDetailsHeader',
  mixins: [ PermisionMixin ],
  data () {
    return {
      showObservations: false,
      obj: null,
      exportFile: false,
      exportObj: {
        days: 0,
        eventFood: '',
        eventMeal: '',
        eventBreakfest: '',
        eventLunch: '',
        eventTransport: ''
      },
      dataSituacao: [],
      role: roles
    }
  },
  computed: {
    HasData () {
      let result = false
      if (this.obj) {
        result = true
      }
      return result
    },
    Code () {
      let result = ''
      if (this.obj) {
        result = this.obj.pedido
      }
      return result
    },
    RequestNumber () {
      let result = ''
      if (this.obj) {
        result = Tools.FormatCode(this.obj.folha)
      }
      return result
    },
    RequestDate () {
      let result = ''
      if (this.obj && this.obj.dataCriacao) {
        result = this.moment(this.obj.dataCriacao).format('DD/MM/YYYY HH:mm')
      }
      return result
    },
    Responsible: function () {
      let result = ''
      if (this.obj && this.obj.responsavel) {
        result = this.obj.responsavel.codigo + '-' + this.obj.responsavel.nome
      }
      return result
    },
    Obra: function () {
      let result = ''
      if (this.obj && this.obj.obra) {
        result += this.obj.obra.referencia + ' - ' + this.obj.obra.localizacao
      }
      return result
    },
    BranchName: function () {
      let result = ''
      if (this.obj && this.obj.secaoRH) {
        if (this.obj.secaoRH.codigo) {
          result = this.obj.secaoRH.codigo + '-'
        }
        result += this.obj.secaoRH.nome
      }
      return result
    },
    Requester: function () {
      let result = ''
      if (this.obj && this.obj.nomeContaAcao) {
        result = this.obj.solicitante.nome
      }
      return result
    },
    Favored: function () {
      let result = ''
      if (this.obj && this.obj.favorecido) {
        result = this.obj.favorecido.nome
      }
      return result
    },
    FavoredPosition: function () {
      let result = ''
      if (this.obj && this.obj.favorecido && this.obj.favorecido.cargo) {
        result = this.obj.favorecido.cargo.nome
      }
      return result
    },
    ReasonTravel: function () {
      let result = ''
      if (this.obj && this.obj.motivoViagem) {
        result = this.obj.motivoViagem.nome
      }
      return result
    },
    TravelPeriod: function () {
      let result = ''
      if (this.obj && this.obj.dataViagemInicio && this.obj.dataViagemFim) {
        result = this.moment(this.obj.dataViagemInicio).format('DD/MM/YYYY') + ' à ' + this.moment(this.obj.dataViagemFim).format('DD/MM/YYYY')
      }
      return result
    },
    TravelCity: function () {
      let result = ''
      if (this.obj && this.obj.destino && this.obj.origem) {
        if (this.obj.origem.estado && this.obj.destino.estado) {
          result = this.obj.origem.nome + '/' + this.obj.origem.estado.sigla + '  à  ' + this.obj.destino.nome + '/' + this.obj.destino.estado.sigla
        } else {
          result = this.obj.origem.nome + ' à ' + this.obj.destino.nome
        }
      }
      return result
    },
    Observations: function () {
      let result = ''
      if (this.obj) {
        result = this.obj.observacao
      }
      return result
    },
    Stage: function () {
      let situa = this.dataSituacao.find((Element) => parseInt(Element.value) === parseInt(this.obj.situacao))
      if (situa !== undefined) {
        return situa.text
      } else {
        return 'N/D'
      }
      // let result = ''
      // if (this.obj && this.obj.hasOwnProperty('situacao')) {
      //   switch (parseInt(this.obj.situacao)) {
      //     case 0: result = 'EM ELABORAÇÃO'
      //       break
      //     case 1: result = 'AGUARDANDO APROVAÇÃO RESPONSÁVEL OBRA'
      //       break
      //     case 2: result = 'AGUARDANDO APROVAÇÃO CONTROLADORIA'
      //       break
      //     case 3: result = 'AGUARDANDO APROVAÇÃO DIRETORIA'
      //       break
      //     case 4: result = 'APROVADO'
      //       break
      //     case 5: result = 'PAGAMENTO REALIZADO'
      //       break
      //     case -1: result = 'REPROVADO APROVACAO CONTRADALODORIA'
      //       break
      //     case -2: result = 'REPROVADO CONTROLADORIAL'
      //       break
      //     case -3: result = 'REPROVADO DIRETORIA'
      //       break
      //     default: result = 'EM ELABORAÇÃO'
      //       break
      //   }
      // }
    }
  },
  mounted () {
    this.showObservations = false
    this.getAllStatus()
  },
  methods: {
    onAddBoard () {
      this.$emit('New')
    },
    onEdit () {
      if (this.HasData) {
        this.$emit('Edit', this.obj)
      }
    },
    onDelete () {
      this.$emit('Delete', this.obj)
    },
    onSectionApproval () {
      this.$emit('SectionApproval', this.obj)
    },
    dowloadPdf () {
      AcceptanceTermRepository.print(this.obj)
        .then(Response => {
          let pdfWindow = window.open('Despesa-Diversos.pdf')
          let pdf = encodeURI(Response.data.data)
          pdfWindow.document.write(`
            <embed width="100%" height="100%" src="data:application/pdf;base64,${pdf}"></embed>
          `)
        })
        .catch(Error => console.log(Error))
    },
    canNotEdit () {
      let situacao = this.obj.situacao
      // Responsavel obra
      if ((situacao === 0 || situacao === -1) && this.hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_WORK_APPROVAL)) return true
      // controladaria
      if ((situacao === 1 || situacao === -1) && this.hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)) return true
      if ((situacao === 2 || situacao === -2) && this.hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)) return true
      if ((situacao === 4 || situacao === -4) && this.hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)) return true
      if ((situacao === 5 || situacao === -5) && this.hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)) return true
      // Diretoria
      if ((situacao === 3 || situacao === -3) && this.hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_BOARD_APPROVAL)) return true
      return false
    },
    onApproval () {
      this.$emit('Approval', this.obj)
    },
    onDisapproval () {
      this.$emit('Disapproval', this.obj)
    },
    onClone () {
      this.$emit('Clone', this.obj)
    },
    onExport () {
      this.$emit('Export', this.exportObj)
    },
    getAllStatus () {
      loading.push()
      ExpenseRepository.GetEnumSituacao()
        .then(Response => {
          loading.pop()
          this.dataSituacao = Response.data
        })
        .catch(Error => loading.pop())
    },
    onload (obj) {
      this.obj.situacao = obj.situacao
    }
  }
}
</script>
<style scoped>
.edit-board {
  display: block;
  position: absolute;
  text-align: right;
  width: 100%;
  right: 15px;
  top: -1px;
}

.edit-board i {
  font-size: 10px;
}
.edit-observations {
  background-color: #fff;
  padding: 10px;
  border: solid 1px #efefef;
  border-radius: 4px;
  width: 100%;
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelrefund/details/components/headerdetails.vue